import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Input } from 'reactstrap';
import './index.scss';


const FilterDropdown = ({ className = '', options,handleVal,val='',disabled = false }) => {
    const handleOnChange = (value) => {
	    handleVal(value);
	  };
      useEffect(()=>{
        console.log("askasruqwieru",val)
      }, [val])
    return (
        <div className={`filter-dropdown ${className}`}>
        <Input disabled={disabled} type="select" name="select"  onChange={($event) => {handleOnChange($event.target.value);}} className="form-select">
					{options && options.map((item, index) => {
						return (<option key={index} selected={item.value === val} value={item.value}>
							{item.label}</option>);

					})}
            </Input>
           
        </div>
    )
}

export default FilterDropdown;